<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 3; backdrop-filter: blur(2px)"
      v-if="loaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container">
      <div
        v-if="
          !loaderStatus &&
          (!this.particularJob.active ||
            this.particularJob.closed ||
            this.particularJob.status != 3)
        "
        class="
          h-100
          d-flex
          justify-content-center
          align-items-center
          flex-column
        "
      >
        <img src="@/assets/img/newkanban/job-not-found.svg" alt />
        <div class="search-text-no-data">
          {{ getJobNotFoundText }}
        </div>
      </div>
      <template v-else>
        <div
          class="
            dashboardAdmin-header
            d-flex
            align-items-center
            justify-content-between
          "
        >
          <div class="d-flex align-items-center">
            <img
              @click="gotoJobs()"
              src="../../assets/img/feedbackform/backarrow.svg"
              class="pointer"
              alt=""
            />
            <div
              ref="select-job"
              @click="jobCards.length > 1 ? toggleJobCard() : ''"
              class="
                dashboardAdmin-header-main-head
                ml-2
                position-relative
                pointer
              "
            >
              <span>{{ particularJob.title }}</span>
              <template v-if="jobCards.length > 1">
                <span v-if="!isJobDropdown" class="ml-2"
                  ><img
                    src="../../assets/img/newkanban/downsmallarrow.svg"
                    alt=""
                /></span>
                <span v-else class="ml-2"
                  ><img
                    src="../../assets/img/newkanban/upsmallarrow.svg"
                    alt=""
                /></span>
              </template>

              <div
                @scroll="onScrollJob"
                ref="close-job"
                v-closable="{
                  exclude: ['close-job', 'select-job'],
                  handler: 'closeJobCard',
                }"
                v-if="isJobDropdown"
                class="kanban-job-dd"
              >
                <div
                  @click="selectJobCard(job)"
                  :class="
                    particularJob.jobID == job.jobID
                      ? 'kanban-job-dd-active'
                      : 'kanban-job-dd-inactive'
                  "
                  v-for="job in jobCards"
                  :key="job.jobID"
                >
                  {{ job.title }}
                </div>
                <div
                  style="margin: auto"
                  v-if="showJobSpinner"
                  class="d-flex justify-content-center mt-2"
                >
                  <b-spinner label="Loading..."></b-spinner>
                </div>
              </div>
            </div>
          </div>
          <div
            class="relativeclass bluebtn"
            ref="addToggle"
            v-closable="{
              exclude: ['addToggle', 'addToggledropdown'],
              handler: 'hideaddToggle',
            }"
          >
            <b-button
              :disabled="particularJob.onHold"
              @click="
                !particularJob.onHold && (thirdParty = false),
                  (addCandidateToggle = !addCandidateToggle)
              "
              class="acs-addBtn-modal padding-6-19 d-flex align-items-center"
            >
              <img
                src="../../assets/img/accessconnew/whitePlus.svg"
                alt=""
                class="mr-2"
              />
              <span class="">Add Candidates</span>
              <img
                v-if="!addCandidateToggle"
                class="ml-2"
                src="../../assets/img/whitedownarrow.svg"
                alt=""
              />
              <img
                v-else
                class="ml-2"
                src="../../assets/img/whiteuparrow.svg"
                alt=""
              />
            </b-button>
            <div
              v-if="addCandidateToggle"
              class="talentPoolcandidateToggle candidate-z-index"
            >
              <div class="pointer unselOption" @click="goToAddCandidate()">
                <img
                  class="mr-2"
                  src="../../assets/talentpool/boldPlus.svg"
                  alt=""
                />
                Add New Candidate
              </div>
              <div class="pointer unselOption" @click="showTalentPool = true">
                <img
                  class="mr-2"
                  src="../../assets/talentpool/boldPlus.svg"
                  alt=""
                />
                Add From Talent Pool
              </div>
              <div
                @click="addMultipleCandidates = true"
                class="pointer unselOption"
              >
                <img
                  class="mr-2"
                  src="../../assets/talentpool/mulCand.svg"
                  alt=""
                />
                Add Multiple Candidates
              </div>
            </div>
          </div>
        </div>
        <div class="kanban-new-maincontainer mt-2">
          <div
            class="
              position-relative
              p-3
              d-flex
              align-items-center
              justify-content-between
              mt-2
            "
          >
            <div class="kanban-new-heading" v-b-modal.tagpanelisttable>
              Kanban
            </div>
            <div class="d-flex">
              <template v-if="particularJob.onHold">
                <img
                  class="mr-2 mt-1"
                  src="../../assets/img/newkanban/kanban-onhold.svg"
                  alt=""
                />
                <span class="kanban-onhold-text mr-2 mt-2">
                  The Job is currently On Hold
                </span>
              </template>
              <div class="bluebtn position-relative">
                <b-button
                  class="acs-addBtn"
                  @click="showFilter()"
                  ref="close-filter"
                  v-closable="{
                    exclude: ['close-filter', 'select-filter'],
                    handler: 'closeKanbanFilter',
                  }"
                  ><img
                    class="mr-2"
                    src="../../assets/img/accessconnew/whiteFilter.svg"
                    alt=""
                  />Filter</b-button
                >
                <div
                  style="left: 23px; top: 8px"
                  class="kanban-filter-count mb-3"
                  v-if="filterApplied"
                ></div>
                <div
                  v-if="isFilter"
                  class="acs-filter p-3"
                  style="width: 300px; top: 35px; right: 0"
                  ref="select-filter"
                >
                  <div>
                    <!-- <div
                                @click.stop=""
                                class="topDiv"
                              >
                              <DateField
                                format="YYYY-MM-DD"
                                type="date"
                                :vmodel="filterObject.selectedDate"
                                :label="'Date'"
                                placeholder="Select date range"
                                id="date-filter-range"
                                :range="true"
                                @select-value="filterObject.selectedDate = $event"
                              />
                              </div> -->
                    <div>
                      <Sourcemulti
                        :id="'source'"
                        :label="'Source'"
                        :placeholder="'Select Source'"
                        :vmodel="filterObject.filterSource"
                        :hideVendor="true"
                        :showThirdParty="false"
                        @setValue="filterObject.filterSource = $event"
                      />
                    </div>
                    <div class="topDiv mt-2" @click.stop="">
                      <FormTags
                        :label="'Skills'"
                        :mandatory="false"
                        :placeholder="'Enter Skills'"
                        :id="'kanbanskills'"
                        @select-value="filterObject.skillSets = $event"
                        :vmodel="filterObject.skillSets"
                      />
                    </div>
                    <!-- <div class="mt-3 panellist-tags aoeskl-field" @click.stop="">
                  <div class="acs-black-txt">Skills :</div>
                  <b-form-tags
                    class="text-truncate filter-input-pan w-100"
                    id="input-1"
                    placeholder="Enter Skills"
                    v-model="filterObject.skillSets"
                    type="text"
                    invalid-tag-text="Duplicate tag(s)"
                    remove-on-delete
                  ></b-form-tags>
                  <div class="hint-txt ml-3 mt-1">
                    Press "Enter" to add skills
                  </div>
                </div> -->

                    <div class="d-flex justify-content-between mt-4 bluebtn">
                      <b-button
                        class="acs-cancelBtn-filter"
                        @click="cancelFilter()"
                        >Cancel</b-button
                      >
                      <div class="d-flex">
                        <b-button
                          class="acs-cancelBtn-filter mr-3"
                          :disabled="disableApplyFilter"
                          @click="
                            disableApplyFilter && filterApplied == false
                              ? ''
                              : filterApplied == false
                              ? clearfilter(false)
                              : clearfilter(true)
                          "
                          >Reset</b-button
                        >
                        <b-button
                          :disabled="
                            disableApplyFilter && filterApplied == false
                          "
                          class="acs-cancelBtn-filter"
                          @click="applyTalentFilterTest()"
                          >Apply</b-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="">
            <b-button class="acs-addBtn">Export Excel</b-button>
          </div> -->
          </div>
          <!-- bind style for 'border-bottom' colors for S NI R OH n Normal rounds -->
          <hr class="m-0" />
          <div
            class="
              px-3
              py-3
              h-88
              d-flex
              align-items-center
              gap-15
              w-100
              overflow-auto
            "
          >
            <div
              class="kanban-card-container py-1"
              v-for="(process, index) in getInterviewProcess"
              :key="process.id"
            >
              <template>
                <div
                  class="kanban-card-header mx-1 d-flex align-items-center"
                  :style="
                    process.id == 'H'
                      ? 'border-bottom: 3px solid #ffc145'
                      : process.id == 'R'
                      ? 'border-bottom: 3px solid #AD1927'
                      : process.id == 'NI'
                      ? 'border-bottom: 3px solid #595959'
                      : process.id == 'P'
                      ? 'border-bottom: 3px solid #269C8A'
                      : 'border-bottom:3px solid #20639b'
                  "
                >
                  <div
                    v-if="!process.type"
                    :class="{
                      'd-flex align-items-center': process.id != 0,
                      'w-90':
                        (!isAsmntIcon(process, index) &&
                          isFilterIcon(process)) ||
                        (!isAsmntIcon(process, index) &&
                          !isFilterIcon(process)) ||
                        (isAsmntIcon(process, index) && !isFilterIcon(process)),
                      'w-75':
                        isAsmntIcon(process, index) && isFilterIcon(process),
                    }"
                  >
                    <div class="mr-1" v-if="process.id != 0">
                      <img :src="getRoundSrc(process.id)" alt="" />
                    </div>
                    <div class="kanban-card-header-text mt-1">
                      {{ getColHeading(process) }}
                    </div>
                  </div>
                  <div
                    :class="{
                      'w-90':
                        (!isAsmntIcon(process, index) &&
                          isFilterIcon(process)) ||
                        (!isAsmntIcon(process, index) &&
                          !isFilterIcon(process)) ||
                        (isAsmntIcon(process, index) && !isFilterIcon(process)),
                      'w-75':
                        isAsmntIcon(process, index) && isFilterIcon(process),
                    }"
                    v-else
                  >
                    <div class="kanban-main-cards-head-type">
                      {{ getColHeading(process) }}
                    </div>
                    <div
                      class="kanban-card-header-text mt-1 text-truncate"
                      style="width: 190px"
                    >
                      {{ process.name }}
                    </div>
                  </div>
                  <div
                    v-if="
                      (process.id != 'P' &&
                        process.id != 'H' &&
                        process.id != 'R' &&
                        process.id != 'NI' &&
                        checkRoundAssessment(index)) ||
                      (process.id == 0 && checkRoundAssessment(index + 1))
                    "
                    :class="
                      (!checkMutiAssessTrigger(process) ||
                        (checkMutiAssessTrigger(process) &&
                          (isSchedule ||
                            viewCandidateModal ||
                            particularJob.onHold))) &&
                      'disabled-kanban-img'
                    "
                    class="pointer"
                    @click="
                      checkMutiAssessTrigger(process) &&
                        !isSchedule &&
                        !viewCandidateModal &&
                        !particularJob.onHold &&
                        triggerMultiple(process, index)
                    "
                  >
                    <img src="../../assets/img/newkanban/asmnt.svg" alt="" />
                  </div>
                  <div
                    class="position-relative unique-filter-id"
                    :class="'unique-filter-id-' + process.id"
                    v-if="isFilterIcon(process)"
                  >
                    <img
                      src="../../assets/img/newkanban/filter.svg"
                      class="pointer"
                      :class="
                        ((displayTotal(index) == 0 &&
                          !uniqueFilter[process.id].filterApplied) ||
                          isSchedule ||
                          viewCandidateModal) &&
                        'disabled-kanban-img'
                      "
                      @click="
                        (uniqueFilter[process.id].filterApplied ||
                          (displayTotal(index) != 0 &&
                            !uniqueFilter[process.id].filterApplied)) &&
                          !isSchedule &&
                          !viewCandidateModal &&
                          showUniqueFilter(process, index)
                      "
                      alt=""
                    />
                    <div
                      class="kanban-filter-count mb-3"
                      v-if="uniqueFilter[process.id].filterApplied"
                    ></div>
                    <div
                      v-if="uniqueFilter[process.id].showFilter"
                      class="acs-filter p-3"
                      style="width: 286px; top: 35px; right: -10px"
                    >
                      <div>
                        <div class="teams-label-font mb-2">Filter By</div>
                        <!-- class="filter-inner" -->
                        <div
                          class="topDiv mt-2"
                          v-if="
                            process.type == 'assesment' &&
                            process.selectedtests.length > 1
                          "
                        >
                          <SelectCustom
                            :from="'scroll-filter'"
                            :placeholder="'Select'"
                            type="filter"
                            :id="'kanban-unique'"
                            :values="testData(process)"
                            :dropdown="true"
                            @select-value="
                              (uniqueFilter[process.id].testID = $event),
                                $forceUpdate()
                            "
                            :vmodel="uniqueFilter[process.id].testID"
                            :label="'Assessment Name:'"
                          />
                        </div>
                        <div class="topDiv mt-2">
                          <SelectCustom
                            :from="'scroll-filter'"
                            :placeholder="'Select'"
                            :id="'kanban-unique'"
                            type="filter"
                            :values="getFilterOptions(process)"
                            :dropdown="true"
                            @select-value="
                              (uniqueFilter[process.id].filterType = $event),
                                $forceUpdate()
                            "
                            :vmodel="uniqueFilter[process.id].filterType"
                            :label="'Status:'"
                          />
                        </div>
                        <div @click.stop="" class="topDiv mt-2">
                          <DateField
                            format="YYYY-MM-DD"
                            type="date"
                            :from="'kanban-unique'"
                            :vmodel="uniqueFilter[process.id].dateRange"
                            :label="'Date:'"
                            placeholder="Date"
                            :range="true"
                            @select-value="
                              (uniqueFilter[process.id].dateRange = $event),
                                $forceUpdate()
                            "
                          />
                        </div>
                        <div
                          class="d-flex justify-content-between mt-3 bluebtn"
                        >
                          <b-button
                            class="acs-cancelBtn-filter"
                            @click="cancelUniqueFilter(process, index)"
                            >Cancel</b-button
                          >
                          <div class="d-flex">
                            <b-button
                              class="acs-cancelBtn-filter mr-3"
                              @click="resetUniqueFilter(process, index)"
                              >Reset</b-button
                            >
                            <b-button
                              :disabled="
                                !uniqueFilter[process.id].filterApplied &&
                                (uniqueFilter[process.id].filterType == '0' ||
                                  uniqueFilter[process.id].filterType == '') &&
                                !uniqueFilter[process.id].testID &&
                                (!uniqueFilter[process.id].dateRange ||
                                  uniqueFilter[process.id].dateRange.length ==
                                    0)
                              "
                              class="acs-cancelBtn-filter"
                              @click="applyUniqueFilter(process, index)"
                              >Apply</b-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div
                    v-if="uniqueFilter[process.id].showFilter"
                    class="allocateradios kanban-more-option-card p-2"
                    style="z-index: 1; width: 270px"
                  >
                    <div class="kanban-filter-heading mb-2">Filter By</div>
                     <template v-if="process.type == 'assesment'">
                    <b-form-group>
                      <b-form-radio-group
                        id="radio-group-1"
                        v-model="uniqueFilter[process.id].filterType"
                        :options="getAssessFilterOptions(process.id)"
                        name="radio-options"
                        stacked
                      ></b-form-radio-group>
                    </b-form-group>
                    <div class="topDiv mt-2 w-100" v-if="process.selectedtests.length > 1">
                        <SelectCustom
                          :from="'scroll-filter'"
                          :placeholder="'Select test'"
                          type="filter"
                          :values="testData(process)"
                          :dropdown="true"
                          @select-value="uniqueFilter[process.id].testID = $event, $forceUpdate()"
                          :vmodel="uniqueFilter[process.id].testID"
                          :label="'Test'"
                        />
                      </div>
                    </template>
                    <b-form-group v-else>
                      <b-form-radio-group
                        id="radio-group-1"
                        v-model="uniqueFilter[process.id].filterType"
                        :options="scheduleFilterOptions(process.id)"
                        name="radio-options"
                        stacked
                      ></b-form-radio-group>
                    </b-form-group>
                    <div
                      class="w-100 d-flex justify-content-between mt-4 bluebtn"
                    >
                      <div>
                        <b-button
                          class="acs-cancelBtn-filter"
                          @click="cancelUniqueFilter(process, index)"
                          >Cancel</b-button
                        >
                      </div>
                      <div class="d-flex">
                        <b-button
                          class="acs-cancelBtn-filter"
                          @click="resetUniqueFilter(process, index)"
                          >Reset</b-button
                        >
                        <b-button
                          class="acs-cancelBtn-filter ml-2"
                          @click="applyUniqueFilter(process, index)"
                          >Apply</b-button
                        >
                      </div>
                    </div>
                  </div> -->
                  </div>
                  <div
                    class="kanban-card-header-number"
                    v-if="roundDetails[`round${process.id}`]"
                  >
                    {{ displayTotal(index) }}
                  </div>
                </div>
                <div
                  v-if="showLoader[index]"
                  class="d-flex align-items-center h-80 mt-2"
                >
                  <SmallSpinner />
                </div>
                <template v-else>
                  <div class="h-90">
                    <div
                      :ref="`candidatetab` + index"
                      class="overflow-auto my-1"
                      @scroll="onScrollcandidates(index, process, $event)"
                      style="height: calc(100vh - 363px)"
                    >
                      <div
                        v-if="!checkMutiAssessTrigger(process)"
                        class="
                          h-100
                          d-flex
                          align-items-center
                          justify-content-center
                          flex-column
                        "
                      >
                        <div>
                          <img
                            src="../../assets/img/newvendorflow/emptyround.svg"
                            alt=""
                          />
                        </div>
                        <div
                          v-if="searchQuery && searchQuery != 'Loader'"
                          class="emptyround-txt-kanban"
                        >
                          No results for "{{ searchQuery }}"
                        </div>
                        <div v-else class="emptyround-txt-kanban">
                          No candidates assigned to this round
                        </div>
                      </div>
                      <template v-else>
                        <div class="text-center" v-if="topSpinners[index]">
                          <b-spinner class="ml-auto"></b-spinner>
                        </div>
                        <div
                          class="px-3 py-2"
                          v-for="candidate in roundDetails[`round${process.id}`]
                            .candidates"
                          :key="candidate.candidateID"
                        >
                          <AddedtoJd
                            v-if="process.id == 0"
                            :type="'vendor'"
                            :candidate="candidate"
                            :isSchedule="isSchedule || viewCandidateModal"
                            :selectedID="selectedID"
                            :jobOnHold="particularJob.onHold"
                            :process="interviewProcess[1]"
                            :vendorRounds="vendorRounds"
                            :selectedCandidate="selectedCandidate"
                            :candidatesToPush="candidatesToPush"
                            :totalPushed="totalPushed"
                            :particularJob="particularJob"
                            @request-docs="requestDocs(candidate)"
                            @sharetoclient="showShareClientModal(candidate)"
                            @select-cand="selCandidate($event)"
                            @trigger-assessment="
                              triggerAssessModal(
                                candidate,
                                interviewProcess[1],
                                'fromadd'
                              )
                            "
                            @schedule-interview="
                              scheduleModal(candidate, interviewProcess[0])
                            "
                            @not-interested="notIntModal(candidate)"
                            @view-candidate="viewCandidate(candidate)"
                            @goto-viewodcs="gotoViewDocs"
                            @show-add-attachment="
                              (showAttachmentInNote = true),
                                addAttachment(candidate)
                            "
                            @show-add-note="
                              (showAttachmentInNote = true),
                                addAddNote(candidate)
                            "
                          />

                          <SharedtoClient
                            v-else-if="process.id == 'P'"
                            :candidate="candidate"
                            :isSchedule="isSchedule || viewCandidateModal"
                            :selectedID="selectedID"
                            :jobOnHold="particularJob.onHold"
                            :selectedCandidate="selectedCandidate"
                            :candidatesToPush="candidatesToPush"
                            :totalPushed="totalPushed"
                            :particularJob="particularJob"
                            @request-docs="requestDocs(candidate)"
                            @view-candidate="viewCandidate(candidate)"
                            @sharetoclient="showShareClientModal(candidate)"
                            @select-cand="selCandidate($event)"
                            @setshareval="shareclient"
                            @goto-viewodcs="gotoViewDocs"
                            @show-add-attachment="
                              (showAttachmentInNote = true),
                                addAttachment(candidate)
                            "
                            @show-add-note="
                              (showAttachmentInNote = true),
                                addAddNote(candidate)
                            "
                          />
                          <Onhold
                            v-else-if="process.id == 'H'"
                            :type="'vendor'"
                            :candidate="candidate"
                            :isSchedule="isSchedule || viewCandidateModal"
                            :selectedID="selectedID"
                            :jobOnHold="particularJob.onHold"
                            :selectedCandidate="selectedCandidate"
                            :particularJob="particularJob"
                            @request-docs="requestDocs(candidate)"
                            @select-cand="selCandidate($event)"
                            @view-candidate="viewCandidate(candidate)"
                            @not-interested="notIntModal(candidate)"
                            @re-assign="reAssignModal(candidate)"
                            @view-feedback="openHistoryModal(candidate)"
                            @goto-viewodcs="gotoViewDocs"
                            @action-modal="openActionModal(candidate, process)"
                            @give-onhold-feedback="
                              giveOnHoldFeedback(candidate, process)
                            "
                            @show-add-attachment="
                              (showAttachmentInNote = true),
                                addAttachment(candidate)
                            "
                            @show-add-note="
                              (showAttachmentInNote = true),
                                addAddNote(candidate)
                            "
                          />
                          <Rejected
                            v-else-if="process.id == 'R'"
                            :type="'vendor'"
                            :candidate="candidate"
                            :isSchedule="isSchedule || viewCandidateModal"
                            :selectedID="selectedID"
                            :jobOnHold="particularJob.onHold"
                            :selectedCandidate="selectedCandidate"
                            :particularJob="particularJob"
                            @select-cand="selCandidate($event)"
                            @view-candidate="viewCandidate(candidate)"
                            @re-assign="reAssignModal(candidate)"
                            @view-feedback="openHistoryModal(candidate)"
                            @action-modal="openActionModal(candidate, process)"
                            @show-add-attachment="
                              (showAttachmentInNote = true),
                                addAttachment(candidate)
                            "
                            @show-add-note="
                              (showAttachmentInNote = true),
                                addAddNote(candidate)
                            "
                          />
                          <NotInterested
                            v-else-if="process.id == 'NI'"
                            :type="'vendor'"
                            :candidate="candidate"
                            :isSchedule="isSchedule || viewCandidateModal"
                            :selectedID="selectedID"
                            :jobOnHold="particularJob.onHold"
                            :selectedCandidate="selectedCandidate"
                            :particularJob="particularJob"
                            :candidatesToPush="candidatesToPush"
                            :totalPushed="totalPushed"
                            @select-cand="selCandidate($event)"
                            :vendorRounds="vendorRounds"
                            @sharetoclient="showShareClientModal(candidate)"
                            @view-candidate="viewCandidate(candidate)"
                            @re-assign="reAssignModal(candidate)"
                            @view-feedback="openHistoryModal(candidate)"
                            @action-modal="openActionModal(candidate, process)"
                            @goto-viewodcs="gotoViewDocs"
                            @show-add-attachment="
                              (showAttachmentInNote = true),
                                addAttachment(candidate)
                            "
                            @show-add-note="
                              (showAttachmentInNote = true),
                                addAddNote(candidate)
                            "
                          />
                          <Assessment
                            v-else-if="process.type == 'assesment'"
                            :type="'vendor'"
                            :candidate="candidate"
                            :isSchedule="isSchedule || viewCandidateModal"
                            :selectedID="selectedID"
                            :jobOnHold="particularJob.onHold"
                            :selectedCandidate="selectedCandidate"
                            :process="interviewProcess[1]"
                            :particularJob="particularJob"
                            @request-docs="requestDocs(candidate)"
                            @select-cand="selCandidate($event)"
                            @trigger-assessment="
                              triggerAssessModal(candidate, process)
                            "
                            @not-interested="notIntModal(candidate)"
                            @re-assign="reAssignModal(candidate)"
                            @give-feedback="
                              giveFeedbackModal(candidate, process)
                            "
                            @view-candidate="viewCandidate(candidate)"
                            @view-feedback="openHistoryModal(candidate)"
                            @goto-viewodcs="gotoViewDocs"
                            @show-add-attachment="
                              (showAttachmentInNote = true),
                                addAttachment(candidate)
                            "
                            @show-add-note="
                              (showAttachmentInNote = true),
                                addAddNote(candidate)
                            "
                          />
                          <FacetoFace
                            v-else-if="process.type == 'f2f'"
                            :type="'vendor'"
                            :candidate="candidate"
                            :isSchedule="isSchedule || viewCandidateModal"
                            :jobOnHold="particularJob.onHold"
                            :selectedID="selectedID"
                            :selectedCandidate="selectedCandidate"
                            :particularJob="particularJob"
                            @request-docs="requestDocs(candidate)"
                            @select-cand="selCandidate($event)"
                            @schedule-interview="
                              scheduleModal(candidate, process)
                            "
                            @not-interested="notIntModal(candidate)"
                            @re-assign="reAssignModal(candidate)"
                            @give-feedback="
                              giveFeedbackModal(candidate, process)
                            "
                            @cancel-meeting="cancelMeet(candidate)"
                            @view-candidate="viewCandidate(candidate)"
                            @view-feedback="openHistoryModal(candidate)"
                            @goto-viewodcs="gotoViewDocs"
                            @show-add-attachment="
                              (showAttachmentInNote = true),
                                addAttachment(candidate)
                            "
                            @show-add-note="
                              (showAttachmentInNote = true),
                                addAddNote(candidate)
                            "
                          />
                        </div>
                        <div class="text-center" v-if="spinners[index]">
                          <b-spinner class="ml-auto"></b-spinner>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>
              </template>
            </div>
          </div>
        </div>

        <!-- Schedule interview container starts -->
        <transition name="slide">
          <ScheduleInterview
            :candidate="selectedCandidate"
            v-if="isSchedule"
            :particularJob="particularJob"
            :toRound="toRound ? toRound.toString() : toRound"
            :remarks="recRemarks"
            :totalNoOfRounds="interviewProcess.length"
            :vendorRounds="vendorRounds"
            @show-alreadyinterviewed="showAlreadyInterview = true"
            @close-schedule="closeScheduleModal"
            @schedule-success="getParticularJob(particularJob.jobID)"
          />
        </transition>
      </template>
    </div>
    <AddFromTalentPool
      v-if="showTalentPool"
      :vendor="'vendor'"
      :showTalentPool="showTalentPool"
      :particularJob="particularJob"
      @view-candidate="selectCand"
      @close-modal="handleTalentPoolClose"
    />

    <ActionModal
      v-if="actionModal"
      :showModal="actionModal"
      :selectedCandidate="selectedCandidate"
      :interviewProcess="interviewProcess"
      :vendorRounds="vendorRounds"
      :particularJob="particularJob"
      @trigger-action="triggerAction"
      @close-modal="closeActionModal"
      @update-details="getParticularJob(particularJob.jobID)"
    />

    <TriggerAssessment
      v-if="trigger"
      :trigger="trigger"
      :selectedCandidate="selectedCandidate"
      :selectedProcess="selectedProcess"
      :particularJob="particularJob"
      :toRound="toRound"
      :type="true"
      :remarks="recRemarks"
      @show-alreadyinterviewed="showAlreadyInterview = true"
      @close-modal="closeTriggerModal"
      @update-details="getParticularJob(particularJob.jobID)"
    />

    <PreviewCandidateSidebar
      v-if="viewCandidateModal"
      :showModal="viewCandidateModal"
      :candidateID="selectedCandidate.candidateID"
      :customFieldsArray="customFieldsArray"
      :showNote="true"
      :jobOnHold="particularJob.onHold"
      :kanbanLevel="selectedCandidate.kanbanLevel"
      :shared="selectedCandidate.pushed"
      :selectedCandidate="selectedCandidate"
      :singleJob="particularJob"
      @close-view-icon="closeViewIcon"
      @goto-viewodcs="gotoViewDocs"
      @add-note="addAddNote()"
    />

    <FeedbackHistory
      v-if="showHistoryModal"
      :candidateID="selectedCandidate.candidateID"
      :jobID="particularJob.jobID"
      :candidateData="selectedCandidate"
      :showModal="showHistoryModal"
      @hideFeedbackhistory="hideFeedbackhistory"
    />
    <NotInterestedModal
      v-if="isNotInterested"
      :isNotInterested="isNotInterested"
      :selectedCandidate="selectedCandidate"
      :particularJob="particularJob"
      @close-modal="closeNotinterestedModal"
      @update-details="getParticularJob(particularJob.jobID)"
    />

    <GiveFeedBack
      v-if="isGiveFeedback"
      :isGiveFeedback="isGiveFeedback"
      :selectedProcess="selectedProcess"
      :selectedCandidate="selectedCandidate"
      :particularJob="particularJob"
      :totalNoOfRounds="interviewProcess.length"
      :vendorRounds="vendorRounds"
      @close-modal="closeGiveFeedback"
      @update-details="getParticularJob(particularJob.jobID)"
    />

    <TriggerMultipleAssessment
      v-if="showMultiTrigger"
      :showMultiTrigger="showMultiTrigger"
      :process="selectedProcess"
      :particularJob="particularJob"
      :viewCandID="viewCandID"
      :level="level"
      @view-candidate="selectCand"
      @trigger-success="getParticularJob(particularJob.jobID)"
      @close-multi-trigger="closeMultipleTrigger"
    />

    <ShareToClientModal
      v-if="showShareToClient"
      :showShareToClient="showShareToClient"
      :candidate="shareCandidate"
      :particularJob="particularJob"
      :shareType="shareType"
      @view-candidate="viewCandidate(shareCandidate)"
      @sharesuccess="getParticularJob(particularJob.jobID)"
      @closesharemodal="(shareCandidate = {}), (showShareToClient = false)"
    />

    <CancelMeetingModal
      v-if="showCancelMeeting"
      :candidate="selectedCandidate"
      :particularJob="particularJob"
      :showCancelMeeting="showCancelMeeting"
      @cancel-success="getParticularJob(particularJob.jobID)"
      @close-cancel="closeCancelMeeting"
    />

    <!-- tag panelist -->
    <AddMultipleExcelModal
      :context="this"
      :particularJob="particularJob"
      @update-talent-pool="getParticularJob(particularJob.jobID)"
      :addMultipleCandidates="addMultipleCandidates"
      v-if="addMultipleCandidates"
      @input="handleAddCandidates"
      :checkMultiple="checkMultiple"
      @closeExcel="handleCloseMultple"
      @closeAddedMultipleExcelCand="handleAdd"
    />
    <AssessmentExpiredModal
      v-if="showExpired"
      :showExpired="showExpired"
      :jobID="particularJob.jobID"
      @close-expired="showExpired = false"
    />
    <AddAttachment
      v-if="showAddAttachment"
      :showAddAttachment="showAddAttachment"
      :candidateID="selectedCandidate.candidateID"
      :jobID="particularJob.jobID"
      @close-modal="closeAttachment"
      @show-add-note="addAddNote()"
    />

    <AddNote
      v-if="showAddNote"
      :showAttachmentInNote="showAttachmentInNote"
      :showAddNote="showAddNote"
      :candidateID="selectedCandidate.candidateID"
      :viewCandidateModal="viewCandidateModal ? false : true"
      :jobID="particularJob.jobID"
      @close-modal="closeAddNote"
      @show-add-attachment="addAttachment()"
    />
    <AlreadyInterviewed
      v-if="showAlreadyInterview"
      :showAlreadyInterview="showAlreadyInterview"
      :vendor="vendor"
      :inAddedToJd="inAddedToJd || !toRound"
      :toRound="
        (!trigger && !toRound) || inAddedToJd
          ? '0'
          : fromAction
          ? (parseInt(toRound) - 1).toString()
          : trigger
          ? selectedProcess.id.toString()
          : toRound
          ? toRound.toString()
          : toRound
      "
      :totalNoOfRounds="interviewProcess.length"
      :vendorRounds="vendorRounds"
      :candidate="selectedCandidate"
      :particularJob="particularJob"
      @close-modal="closeAlreadyModal"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import KanbanMixin from "../../components/mixin/kanbanMixin";

export default {
  mixins: [KanbanMixin],
  data() {
    return {
      options: [
        { text: "All", value: "", default: true },
        { text: "Internal Department", value: "1" },
        { text: "Client Hiring", value: "2" },
      ],
      thirdParty: false,
      addCandidateToggle: false,
      page: 0,
      count: 50,
      sortColumn: "updatedAt",
      sortOrder: "-1",
      isJobDropdown: false,
    };
  },
  computed: {
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
    ...mapGetters("jobDescriptionVUEX", {
      storedData: "getSelectedCandidate",
    }),
  },
  methods: {
    scrollSlightlyUp(index) {
      const container = this.$refs[`candidatetab${index}`];
      const element = container ? container[0] : null;
      if (element) {
        element.scrollTo({
          top: element.scrollTop - 900,
          behavior: "smooth",
        });
      }
    },
    scrollToBottom(index) {
      const container = this.$refs[`candidatetab${index}`];
      const element = container ? container[0] : null;
      if (element) {
        element.scrollTo({
          top: 1100,
          behavior: "smooth",
        });
      }
    },
    gotoJobs() {
      this.$router.push({
        name: "jobs",
        params: {
          vendorID: this.$route.params.vendorID,
          client: this.$route.params.client,
        },
        query: {
          clientName: this.$route.query.clientName,
        },
      });
    },
    hideaddToggle() {
      this.addCandidateToggle = false;
    },
    closeJobCard() {
      this.isJobDropdown = false;
    },
    gotoviewdocs() {
      this.$router.push({ name: "viewcandidatedocs" });
    },
  },
};
</script>

<style>
.exc-bluetab {
  font-family: "Lato", sans-serif;
  font-size: var(--size-16);
  font-weight: var(--weight-B);
  color: var(--bluetheme);
  position: relative;
  height: 48px;
  width: 145px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 20px;
}

.exc-blacktab {
  font-family: "Lato", sans-serif;
  font-size: var(--size-16);
  font-weight: var(--weight-LM);
  color: var(--black);
  position: relative;
  height: 48px;
  width: 145px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 20px;
}

.exc-sel-tab {
  position: absolute;
  border-bottom: 4px solid #20639b;
  box-shadow: 0px 4px 8px 0px #0000002b;
  width: 100%;
  height: 4px;
  border-radius: 25px 25px 6px 6px;
  bottom: 0px;
  left: 0px;
}

.exc-seacrh .search-input {
  height: 35px;
  background: #72738e14;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 0 10px 0 30px !important;
  width: 100%;
  border: none;
}

.exc-seacrh .search-input:focus {
  background: #72738e14;
}

.exc-seacrh .search-input::placeholder {
  color: #72738e80;
  font-family: var(--montserrat);
  font-size: 14px;
  font-weight: 400;
}

.exc-main-table {
  width: 100%;
  position: relative;
  height: calc(100vh - 385px);
  overflow-x: auto;
  overflow-y: hidden;
}

.exc-table-head {
  min-width: 1000px;
  max-width: 100%;
  display: flex;
  align-items: center;
  padding: 8px 0px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #20639b;
  font-family: "lato", sans-serif;
  background: #20639b1a;
}

.exc-table-body {
  min-width: 1000px;
  max-width: 100%;
  overflow-y: auto;
  height: 88%;
}

.exc-table-row {
  width: 100%;
  position: relative;
  border-radius: 5px;
  border: 0.5px solid #e5e5e5;
  background: #fcfcfc;
  box-shadow: 0px 4px 15px 0px #c4c4c480;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 15px;
  color: #20639b;
  font-family: "lato", sans-serif;
  padding: 5px 0px;
  margin: 8px 0px;
}

.exc-table-row:hover {
  background: #e7e8f5;
}
.exc-main-table .custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #20629b;
  background-color: #20639b;
}
.exc-bluebtn {
  width: 95%;
  /* padding: 7px 23px; */
  border: 1px solid #20639b;
  box-shadow: 0px 4px 20px 0px #1a416433;
  border-radius: 35px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "montserrat", sans-serif;
  font-size: var(--size-13);
  font-weight: var(--weight-M);
  color: var(--bluetheme);
}

.exc-redbtn {
  width: 95%;
  /* padding: 7px 23px; */
  border: 1px solid #eb000280;
  border-radius: 35px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "montserrat", sans-serif;
  font-size: var(--size-13);
  font-weight: var(--weight-M);
  color: #eb0002;
}

.exc-greenbtn {
  width: 95%;
  /* padding: 7px 23px; */
  border: 1px solid #038e0080;
  border-radius: 35px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "montserrat", sans-serif;
  font-size: var(--size-12);
  font-weight: var(--weight-M);
  color: #7a7a7a;
}
.talentPoolcandidateToggle {
  position: absolute;
  top: 35px;
  right: 0px;
  background: #ffffff;
  box-shadow: 0px 1px 11px 0px #00000061;
  border-radius: 5px;
  padding: 10px;
  z-index: 3;
  width: 240px !important;
}

.talentPoolcandidateToggle .unselOption {
  font-weight: 600;
  font-family: "lato", sans-serif;
  font-size: 13px;
  padding: 8px !important;
  color: #3a3c40;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.talentPoolcandidateToggle .unselOption:hover {
  background: #e8eff4;
}

.talentPoolcandidateToggle .selOption {
  font-weight: 600;
  font-family: "lato", sans-serif;
  font-size: 13px;
  padding: 8px !important;
  color: #3a3c40;
  background: #e8eff4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
}

.talentpool-thirdparty-unsel {
  color: var(--bluetheme);
  font-weight: var(--weight-M);
  font-family: "lato", sans-serif;
  font-size: var(--size-14);
  padding: 8px;
}

.talentpool-thirdparty-unsel:hover {
  background: #e8eff4;
  border-radius: 4px;
}

.talentpool-thirdparty-sel {
  color: var(--bluetheme);
  font-weight: var(--weight-M);
  font-family: "lato", sans-serif;
  font-size: var(--size-14);
  padding: 8px;
  background: #e8eff4;
  border-radius: 4px;
}
</style>
